import layout from '@/views/layout/layout.vue'
const installRegisterList = r => require.ensure([], () => r(require('@/views/ywt/installRegister/list.vue')), 'group-ywt-member')

const ywtInstallRegister = [
  {
    path: '/ywt/installRegister',
    name: 'ywt-installRegister',
    component: layout,
    redirect: '/ywt/installRegister/list',
    children: [
      {
        path: 'list',
        name: 'ywt-installRegister-list',
        component: installRegisterList,
        meta: {
          displayName: '质保登记',
          requireAuth: true
        }
      }
    ]
  }
]

export default ywtInstallRegister



// WEBPACK FOOTER //
// ./src/router/ywt/installRegister.js